// extracted by mini-css-extract-plugin
module.exports = {"blueText":"styles-module--blueText--2Gy7H","light":"styles-module--light--2wvGj","squared":"styles-module--squared--2m78e"};